import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import environment from './base';
var env = environment();
export default _objectSpread(_objectSpread({}, env), {}, {
  "apiSubscription": "b703b1ab02214681b39968a756f4f2c7",
  "apiSubscriptionB2C": "3797bee6b2b748a3b6596f16dc90f745",
  "apiUrl": "https://cbapiprd.azure-api.net",
  "omniUrl": "https://omnipay.crackerbarrel.com",
  "apiVersion": "v1",
  "sitecoreApiUrl": "",
  "tokenExIframe": 'https://htp.tokenex.com/iframe/iframe-v3.min.js',
  "tokenExId": '6261499618372902',
  "openJobsUrl": "https://careers.crackerbarrel.com/jobs"
});